// extracted by mini-css-extract-plugin
export default {"hoverEffect":"ArticleFooter_hoverEffect__m3UzK"};